// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"Snackbar_snackbar__2YrJq","show":"Snackbar_show__W5oak","fadein":"Snackbar_fadein__3p53a","fadeout":"Snackbar_fadeout__HRSVh"};